export enum shops {
  mybio = 1,
  metro = 2,
}

export const isMetroShop = (shopId): boolean => +shopId === shops.metro;
